export default __webpack_public_path__ + "resources/icons/n340-8fb1.png";